import React from 'react';
import {navigate} from '../../components/root_navigation';
import {preloadCameraIfEnabled} from '../../helpers/preloadCamera';

export function openPackingCam(config, {order, remainingModules, toteInput}) {
  return async (dispatch, getState) => {
    const bothSettingsData = getState().user?.bothSettings?.data?.data;
    const scanPackSettings = bothSettingsData?.scanpack_setting;
    const cameraRef = React.createRef();
    await preloadCameraIfEnabled(
      cameraRef,
      null,
      scanPackSettings,
      order?.storeinfo?.disable_packing_cam,
      bothSettingsData?.packing_cam,
      bothSettingsData?.post_scanning_config?.modules_config
    );

    config.setLoading(dispatch, false);

    const params = {
      order,
      cameraInstance: cameraRef.current,
      cameraOption: scanPackSettings?.capture_image_option || 'Manual',
      [config.packingCam.returnParam]: true,
      postScanningModulesRemaining: remainingModules
    };
    if (config.packingCam.carriesToteInput) {
      params.postScanningToteInput = toteInput;
    }
    navigate('PackingCam', params);
  };
}

export function promptRecordTracking(config, params) {
  return dispatch => {
    config.setLoading(dispatch, false);
    config.showPrompt(dispatch, {promptType: 'PostScanRecordTracking', ...params});
  };
}

export function promptVerifyShipping(config, params) {
  return dispatch => {
    config.setLoading(dispatch, false);
    config.showPrompt(dispatch, {promptType: 'PostScanVerifyShipping', ...params});
  };
}

// Skipped when the order has no label. `print_ss_label` is not on every
// workflow's order payload, so a workflow can supply its own check.
export function openShippingLabel(config, params) {
  return (dispatch, getState) => {
    const {isApplicable, navigate} = config.shippingLabel;
    const applicable = isApplicable
      ? isApplicable(getState(), params.order)
      : Boolean(params.order?.print_ss_label);
    if (!applicable) return false;
    config.setLoading(dispatch, false);
    navigate(dispatch, getState, params);
    return true;
  };
}
